export class NonWorkRelatedTimeEntryMeta {}
